export default __webpack_public_path__ + "static/collective-e76ed20ef814cb5a86d8daf47fbb7f22.svg";